import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { Box, Button, Flex, FormControl, FormLabel, Grid, GridItem, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Select, Text, Textarea, VStack } from '@chakra-ui/react'
import { QUOTE_ADDITIONAL_ITEM_CATEGORIES, getAssetUrl } from 'lib'

export const ModalProjectChangeOrderApproved = ({ isOpen, onClose, changeOrder }) => {
  const lineItems = useMemo(() => {
    return changeOrder?.lineItems ? JSON.parse(changeOrder.lineItems) : []
  }, [changeOrder?.lineItems])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Change Order</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack alignItems="none" gap={4}>
            <Grid templateColumns="repeat(2, 1fr)" gap={4}>
              <GridItem>
                <FormControl>
                  <FormLabel>Item Name</FormLabel>
                  <Input name="name" value={changeOrder?.name || ''} isReadOnly={true} />
                </FormControl>
              </GridItem>
            </Grid>
            <Heading size="sm">Line Item(s)</Heading>
            <VStack alignItems="none" gap={2}>
              {!lineItems.length && (
                <Text fontSize="sm">No line items.</Text>
              )}
              {lineItems.map(item => {
                return (
                  <Box key={item.id}>
                    <FormControl>
                      <FormLabel>Item Description</FormLabel>
                      <Textarea name="description" value={item.item} rows="3" isReadOnly={true} />
                    </FormControl>
                    <Flex justifyContent="space-between" gap={4} alignItems="flex-end" mt={2}>
                      <FormControl>
                        <FormLabel>Category</FormLabel>
                        <Select name="category" value={item.category} placeholder="Select" isDisabled={true}>
                          {Object.keys(QUOTE_ADDITIONAL_ITEM_CATEGORIES).map(v => {
                            return (
                              <option key={QUOTE_ADDITIONAL_ITEM_CATEGORIES[v]} value={QUOTE_ADDITIONAL_ITEM_CATEGORIES[v]}>{QUOTE_ADDITIONAL_ITEM_CATEGORIES[v]}</option>
                            )
                          })}
                        </Select>
                      </FormControl>
                      <FormControl>
                        <FormLabel>Price</FormLabel>
                        <NumberInput
                          value={item.price}
                          min={0}
                          step={0.01}
                          isReadOnly={true}
                        >
                          <NumberInputField />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </FormControl>
                    </Flex>
                  </Box>
                )
              })}
            </VStack>
            <Flex justifyContent="center" w="fit-content" gap={4}>
              <Text fontSize="sm">Signed Doc</Text>
              <Button
                size="sm"
                variant="link"
                colorScheme="blue"
                onClick={() => window.open(getAssetUrl(changeOrder?.signedDoc))}
              >
                View
              </Button>
            </Flex>
            <FormControl isRequired>
              <FormLabel>Notes</FormLabel>
              <Textarea name="notes" value={changeOrder?.notes} isReadOnly={true} />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="gray" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ModalProjectChangeOrderApproved.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  changeOrder: PropTypes.object
}
